module.exports = __webpack_public_path__ + "assets/img/youtube.1d3ba171.svg";